import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Protection } from './Protection';
import { Team } from './Team';
import { Account } from './Account';
import { Notifications } from './Notifications';
import { TrackingPage } from './Tracking/TrackingPage';
import { Invites } from './Invites';
import { Integrations } from './Integrations';
import { AutomationRules } from './AutomationRules';
import { OrderSettings } from './OrderEditing/OrderSettings';
import Impact from './Impact';
import General from './ResolutionPortal/General';
import Portal from './ResolutionPortal/Portal';
import Resolutions from './ResolutionPortal/Resolutions';
import Media from './ResolutionPortal/Media';
import { BillingInvoices } from './BillingInvoices';
import { BillingProfile } from './BillingProfile';
import StoreBilling from './StoreBilling';
import PolicySettings from './ResolutionPortal/PolicySettings';
import ExchangeSettings from './ResolutionPortal/ExchangeSettings';
import IncentiveSettings from './ResolutionPortal/IncentiveSettings';
import CarrierSettings from './ResolutionPortal/CarrierSettings';
import { PricingSettings } from './PricingSettings';

export const Settings = () => {
  return (
    <div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8"></div>
      <Routes>
        <Route
          index
          element={<Navigate to="/settings/protection" replace={true} />}
        />
        <Route path="/pricing" element={<PricingSettings />} />
        <Route path="/impact" element={<Impact />} />
        <Route path="/order-settings/*" element={<OrderSettings />} />
        <Route path="/protection" element={<Protection />} />
        <Route path="/resolution-portal/general" element={<General />} />
        <Route path="/resolution-portal/portal" element={<Portal />} />
        <Route
          path="/resolution-portal/resolutions"
          element={<Resolutions />}
        />
        <Route path="/resolution-portal/media" element={<Media />} />
        <Route
          path="/resolution-portal/returns/policy"
          element={<PolicySettings key="policy" />}
        />
        <Route
          path="/resolution-portal/returns/settings"
          element={<PolicySettings key="returns" settingsPage="returns" />}
        />
        <Route
          path="/resolution-portal/returns/exchanges"
          element={<ExchangeSettings />}
        />
        <Route
          path="/resolution-portal/returns/incentives"
          element={<IncentiveSettings />}
        />
        <Route
          path="/resolution-portal/returns/notifications"
          element={
            <Navigate to="/settings/notifications?tab=returns" replace={true} />
          }
        />
        <Route
          path="/resolution-portal/returns/carriers"
          element={<CarrierSettings />}
        />
        <Route
          path="/resolution-portal/returns/approval"
          element={<PolicySettings key="approval" settingsPage="approval" />}
        />
        <Route path="/team" element={<Team />} />
        <Route path="/team/invites" element={<Invites />} />
        <Route path="/account" element={<Account />} />
        <Route path="notifications" element={<Notifications />} />
        <Route path="tracking-templates" element={<TrackingPage />} />
        <Route path="/integration" element={<Integrations />} />
        <Route path="/claim-automations" element={<AutomationRules />} />
        <Route path="/billing/invoices" element={<BillingInvoices />} />
        <Route path="/billing/profile" element={<BillingProfile />} />
        <Route path="/billing/subscription" element={<StoreBilling />} />
      </Routes>
    </div>
  );
};
